
import { replaceBucketKeysWithUrlsInArray } from '@shootsta/client-aws-s3';

export default function resolveProfileImages(
members,
organisationId,
apiClient)
{
  if (!members.length || !organisationId) {
    return members.map((member) => ({ ...member, imageUrl: void 0 }));
  }

  try {
    return replaceBucketKeysWithUrlsInArray({
      apiClient,
      dataArray: members,
      organisationId,
      substitutedKeys: ['imageUrl']
    });
  } catch (e) {
    return members.map((member) => ({ ...member, imageUrl: void 0 }));
  }
}